import React, { Component } from 'react';
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  TextInput,
  Image,
  FlatList,
  SafeAreaView,
  Platform,
  Dimensions,
} from 'react-native';
import colors from '../HelperClasses/AppColor';
import networkService from '../Network/NetworkManager';
import Appload from '../HelperClasses/AppLoaderClasses/AppLoader';
import PropTypes from 'prop-types';
import Header_View from '../Settings/HeaderView';
import { AppToast } from '../HelperClasses/AppToast';
import commonStyle from '../StyleSheets/CommonStyleSheet';
import downArrow_Icon from '../assets/downArrowIcon.png';
import appConfigStyle from '../StyleSheets/AppConfigStyleSheet';
import ReactFileReader from 'react-file-reader';
import blackCrossIcon from '../assets/blackCrossIcon.png';
import upload_Icon from '../assets/uploadIcon.png';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';
import SelectSearchView from 'react-select';
import { ToastContainer } from 'react-toastify';
import MediaManagerView from '../Component/MediaManagerView';
import DescriptionView from '../Component/DescriptionView';
import Moment from 'moment';
// import DatePicker from 'react-custom-date-picker';
import { SketchPicker } from 'react-color';
import MapPicker from 'react-google-map-picker';
import DatePicker from 'react-datepicker';
import jsonIcon from '../assets/jsonIcon.png';
import pdfIcon from '../assets/pdfICon.png';
import closeIcon from '../assets/closeIcon.png';
import Switch from 'react-switch';
import calendarIcon from '../assets/calendarIcon.png';
import deleteIcon from '../assets/delete_icon.png';

import 'react-datepicker/dist/react-datepicker.css';
import tableStyle from '../StyleSheets/TableCommonStyleSheet';
import previewStyleSheet from '../StyleSheets/PreviewStyleSheet';
import { addMixpanelEvent, MixPannelEnum } from '../Models/MixPannelEnum';
import { Gradient } from 'react-gradient';
import {
  changeDateFormat,
  checkUserRoleModule,
  convertTimeinto12Hrs,
  convertTimeinto24Hrs,
  getTimeArray,
  getTimeDifferenceArray,
} from '../HelperClasses/SingletonClass';
import AppConstants, { moduleType } from '../Constants/AppConstants';
import { ModuleType } from '../Models/ModuleType';
import ConstantArray from '../Constants/ConstantArray';
import CommonStyleSheet from '../StyleSheets/CommonStyleSheet';
import TextTitleStyleSheet from '../StyleSheets/TextTitleStyleSheet';
import ToolTipViewBtn from '../Component/ToolTipViewBtn';
import FilePicker from '../Component/FilePicker';
import backIcon from '../assets/backIcon.png';
import styles from '../StyleSheets/NewStyleSheet';
import SaveButton from '../Component/SaveButton';
import { withRouter } from '../wrappers/withRouter';
import SidePan from '../Shared/SidePan';
import AddCategory from '../Settings/Listings/AddCategory';
import { ReactComponent as RefreshIcon } from '../assets/refresh.svg';
import ListingsHeaderV2 from './ListingsHeaderV2';
import {ThemeContext} from '../HelperClasses/ThemeContext';
import {withLocale} from '../Localization/LocaleContext';
import {clearListingDraft, listingDraftKey, readListingDraft, writeListingDraft} from './listingDrafts';
import {translateRepeatOption, translateRepeatSchedule, translateWeekday} from '../Localization/scheduleLabels';

import GithubSlugger, { slug as slugChecker } from 'github-slugger';
import { MODULEKEYS } from '../Models/Enum';
import SetupUserForm from './ManualAddListing/SetupUserForm';
import SetupAccount from './ManualAddListing/SetupAccout';
import GenerateText from '../utils/AI/GenerateText';
import { instructions } from '../Constants/Instructions';
import { replacePlaceholders } from '../utils/replacePlaceholders';
import ToastPopup from '../HelperClasses/AppLoaderClasses/ToastPopup';
import Attributes from '../Attributes/Attributes';
import { upload_attributes_files } from '../Actions/uploadAttrData';
import AddDigitalProduct from './DigitalProduct/AddDigitalProduct';
import { upload_digital_products } from './functions/uploadDigitalProduct';
import TradlyMediaPicker from '../Component/TradlyMediaPicker';
import { uploadImageAPI } from '../utils/uploadImage';
const windowWidth = Dimensions.get('window').width;
const windowHeight = Dimensions.get('window').height;

let fixedWidth = AppConstants.mobileMaxWidth;
let dateFormat = 'yyyy-MM-DD HH:mm:ss';
var dt = new Date();
let currentDate = Moment(dt).format(dateFormat);
const APPURL = require('../Constants/URLConstants');
var pageNo = 1;
const DefaultLocation = { lat: 10, lng: 106 };
const DefaultZoom = 10;

let itsMobileView = windowWidth < fixedWidth ? true : false;

class AddListings extends Component {
  t = (key, fallback) => this.props.localeContext?.translate?.(key, fallback) || fallback || key;
  static contextType = ThemeContext;
  constructor(props) {
    super(props);
    this.listingFormDraftKey = listingDraftKey(props);
    this.listingFormDraftSaved = false;
    this.state = {
      showDropDown: [false, false],
      showAttributeDropDown: false,
      status: false,
      default: false,
      dataLoad: false,
      updateUI: false,
      id: '',
      rank: '',
      currencyArray: [],
      categoriesArray: [],
      updatingBool: false,
      selectedCurrency: '',
      selectedCurrencyCODE: '',
      selectedCurrencyID: '',
      selectedCategory: '',
      selectedCategoryID: [],
      descriptionString: '',
      titleString: '',
      code: '',
      regexp: /^[0-9\.]+$/,
      listPriceValue: '',
      stockValue: '',
      offerPercentage: '',
      maxQuantity: '',
      imagesArray: [],
      tags: [],
      attributesArray: [],
      attributes: [],
      attributeData: [],
      selectedAttributeArray: [],
      uploadAttributeImagesURL: [],
      pictureCount: 20,
      showStock: false,
      showMAxQty: false,
      showOffer: false,
      showTag: false,
      mediaArray: [],
      showMediaManager: false,
      descriptionHeight: 40,
      usedLines: 1,
      height: 40,
      showColorPicker: [],
      latitude: 0.0,
      longitude: 0.0,
      jsonFile: [],
      showMapView: false,
      startDate: new Date(),
      calenderOn: false,
      selectedCategoryArray: [],
      attributeImageIndex: -1,
      attributeImageID: 0,
      slugValue: '',
      showSlug: false,
      accountID: '',
      metaTitle: '',
      metaDescriptionString: '',
      showAddScheduleViewBool: false,
      scheduleStartDate: new Date(),
      scheduleEndDate: new Date(),
      showScheduleRepeatBool: false,
      selectedRepeatIndex: -1,
      selectedWeekDay: [],
      scheduleArray: [],
      showSlotBool: false,
      showTimeBool: [false, false],
      scheduleStartTime: '09:00 am',
      scheduleEndTime: '05:00 pm',
      selectedSlot: slotArray[3]['name'],
      showMetaTitle: false,
      showMetaDescription: false,
      showMetaKeyboard: false,
      saveAsDraft: false,
      openSidepan: false,
      writeP: AppConstants.defaultWrite,
      readP: AppConstants.defaultWrite,
      deleteP: AppConstants.defaultDelete,
      is_set_new_user: false,
      selectedUser: null,
      selectedAccount: null,
      listing_taxes: [],
      selected_listing_tax: null,
      showTaxDropDown: false,
      digitalProducts: {
        active: true,
        account_id: '',
        title: '',
        description: '',
        version_name: '',
        content: [],
      },
      order_type: 'listings',
      ...readListingDraft(this.listingFormDraftKey),
    };
  }
  static propTypes = {
    backBtnAction: PropTypes.func,
    languageData: PropTypes.any,
    isEdit: PropTypes.bool,
    listingDetailData: PropTypes.any,
  };
  componentDidMount() {
    this.loadMediaAPi();
    if (this.props.isEdit) {
      const { listingID } = this.props.params;
      this.fetchListingDetailsData({ listingID });
    }
    this.loadCurrencyApi();
    this.loadCategoryApi();
    this.loadConfigApi();
    this.checkModule();
    this.loadListingTaxApi();
  }
  checkModule = () => {
    checkUserRoleModule(MODULEKEYS.LISTIINGS, res => {
      this.setState({ readP: res[0], writeP: res[1], deleteP: res[2] });
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (!this.listingFormDraftSaved) writeListingDraft(this.listingFormDraftKey, this.state);
    if (this.state.openSidepan !== prevState.openSidepan) {
      this.loadCategoryApi();
    }
  }

  loadMediaAPi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.media + `?page=${pageNo}&parent=0`,
      'get',
      '',
      '',
    );
    this.setState({ mediaArray: [] });
    if (responseJson['status'] == true) {
      var mediaD = responseJson['data']['media'];
      if (mediaD.length != 0) {
        this.setState({ mediaArray: [] });
        this.setState({ stopPage: false });
        for (let obc of mediaD) {
          this.state.mediaArray.push(obc);
        }
      } else {
        pageNo = pageNo > 1 ? pageNo - 1 : 1;
        this.setState({ stopPage: true });
      }
    }
    this.setState({ dataLoad: true });
  };

  fetchListingDetailsData = async ({ listingID }) => {
    this.setState({ dataLoad: false });

    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.listingsModerate + `/${listingID}`,
      'get',
    );
    if (responseJson['status'] == true) {
      let dataObjc = responseJson['data']['listing'];
      this.getListingData(dataObjc);
    }
    this.setState({ dataLoad: true });
  };

  getListingData(listing_details) {
    if (listing_details) {
      this.state.id = listing_details?.id ?? '';
      this.state.titleString = listing_details?.title ?? '';
      this.state.descriptionString = listing_details?.description ?? '';
      this.state.slugValue = listing_details?.slug ?? '';

      if (listing_details?.list_price) {
        this.state.listPriceValue = listing_details?.list_price?.amount ?? '';
      }
      this.state.offerPercentage = listing_details?.offer_percent ?? '';
      this.state.stockValue = listing_details?.stock ?? '';
      this.state.maxQuantity = listing_details?.max_quantity ?? '';
      this.state.selectedCurrencyID = listing_details?.currency_id ?? '';
      this.state.metaTitle = listing_details?.meta_title ?? '';
      this.state.metaDescriptionString =
        listing_details?.meta_description ?? '';
      this.state.accountID = listing_details?.account?.id ?? '';
      this.state.selectedAccount = listing_details?.account ?? null;
      this.state.selected_listing_tax =
        listing_details?.listing_taxes[0] ?? null;
      this.state.order_type = listing_details?.order_type ?? 'listings';
      // this.state.scheduleArray =
      let schedules = listing_details?.schedules ?? [];
      for (let scObj of schedules) {
        let timeArray = [];
        let repeatClass = scObj?.repeat_days ?? [];
        var repeatIDs = '1,7';
        var repeatName = '';
        var repeatIndex = 0;
        repeatIDs = repeatClass.toString();
        let index = ConstantArray.repeatArray.findIndex(x => x.id == repeatIDs);
        if (index == -1) {
          repeatIndex = 3;
          var nameary = [];
          for (let objc of repeatClass) {
            let ind = ConstantArray.weekDays.findIndex(x => x.id == objc);
            nameary.push(ConstantArray.weekDays[ind].name);
          }
          if (nameary.length != 0) {
            repeatName = nameary.toString();
          }
        } else {
          repeatIndex = index;
          repeatName = ConstantArray.repeatArray[index].name;
        }
        let reactDic = {
          name: repeatName,
          ids: repeatIDs,
        };
        let timeDic = {
          start: convertTimeinto12Hrs(scObj['start_time']),
          end: convertTimeinto12Hrs(scObj['end_time']),
        };
        let dict = {
          startDate: scObj['start_date'],
          startTime: scObj['start_time'],
          endTime: scObj['end_time'],
          slot: '60',
          repeatClass: reactDic,
        };
        let dIndex = this.state.scheduleArray.findIndex(
          x => x['startDate'] == scObj['start_date'],
        );
        if (dIndex == -1) {
          timeArray.push(timeDic);
          dict['timeSlots'] = timeArray;
          this.state.scheduleArray.push(dict);
        } else {
          let getTimeAry = this.state.scheduleArray[dIndex];
          timeArray = [...getTimeAry['timeSlots']];
          timeArray.push(timeDic);
          this.state.scheduleArray[dIndex]['timeSlots'] = timeArray;
        }
      }

      for (let tag of listing_details['tags']) {
        this.state.tags.push(tag['name']);
      }
      if (listing_details['account']) {
        this.state.accountID = listing_details['account']['id'];
      }
      let images = listing_details['images'];
      for (let img of images) {
        // const dic = {
        //   image: img,
        //   name: 'backend',
        //   type: 'image/png',
        // };
        this.state.imagesArray.push(img);
      }
      // Handle multiple categories
      if (listing_details['categories'] && listing_details['categories'].length > 0) {
        this.state.selectedCategoryID = listing_details['category_id'] || [];

        for (let category of listing_details['categories']) {
          let ccData = category['hierarchy'] || [];
          for (let cad of ccData) {
            var dic = { ...cad };
            dic['value'] = cad['id'];
            dic['label'] = cad['name'];
            this.state.selectedCategoryArray.push(dic);
          }
        }
        // Load attributes for all selected categories (comma-separated IDs)
        if (this.state.selectedCategoryID.length > 0) {
          this.loadAttributesApi(this.state.selectedCategoryID.join(','));
        }
      }
      if (listing_details['attributes']?.length > 0) {
        const attributes = listing_details['attributes'];
        let attributeData = [];
        attributes.filter(attr => {
          if (
            (attr.field_type === 1 || attr.field_type === 2) &&
            attr.values?.length > 0
          ) {
            attributeData.push({
              id: attr.id,
              values: attr.values.map(item => item.id),
            });
          } else if (
            (attr.field_type === 3 || attr.field_type === 4) &&
            attr.values?.length > 0
          ) {
            attributeData.push({
              id: attr.id,
              values: attr.values.map(item => item),
            });
          } else if (
            (attr.field_type === 5 ||
              attr.field_type === 13 ||
              attr.field_type === 14) &&
            attr.values?.length > 0
          ) {
            attributeData.push({
              values: attr.values,
              id: attr.id,
            });
          } else if (
            (attr.field_type === 6 ||
              attr.field_type === 7 ||
              attr.field_type === 8 ||
              attr.field_type === 9 ||
              attr.field_type === 10 ||
              attr.field_type === 11 ||
              attr.field_type === 12) &&
            attr.values?.length > 0
          ) {
            attributeData.push({
              values: attr.values,
              id: attr.id,
            });
          }
        });
        this.setState({ attributeData });
      }
      const draft = readListingDraft(this.listingFormDraftKey);
      if (Object.keys(draft).length > 0) Object.assign(this.state, draft);
      this.setState({ updateUI: !this.state.updateUI });
    }
  }

  loadListingTaxApi = async () => {
    try {
      this.setState({ isVisible: true }); // Show loading

      const responseJson = await networkService.networkCall(
        APPURL.URLPaths.tax + `?type=listing_tax`,
        'get',
        '',
      );

      if (responseJson['status'] === true) {
        const taxes = responseJson['data']['taxes'] || [];
        this.setState({
          listing_taxes: taxes,
        });
      } else {
      }
    } catch (error) {
      console.log('Error loading taxes:', error);
    }
  };
  //MARK:- Api Methods
  loadConfigApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.config + '?key_group=listings',
      'get',
    );
    if (responseJson['status'] == true) {
      var configs = responseJson['data']['configs'];
      this.setState({
        pictureCount: configs['listing_pictures_count'] || 1,
        showStock: configs['enable_stock'] || false,
        showMAxQty: configs['show_max_quantity'] || false,
        showOffer: configs['hide_offer_percent'] || false,
        showTag: configs['listing_hide_tags'] || false,
        showSlug: configs['enable_slug'] || false,
        showMetaTitle: configs['meta_title'] || false,
        showMetaDescription: configs['meta_description'] || false,
      });
    }
    this.setState({ dataLoad: true });
  };
  loadCurrencyApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.currencies,
      'get',
    );
    if (responseJson['status'] == true) {
      this.setState({ currencyArray: [] });
      var currencyD = responseJson['data']['currencies'];
      for (let i = 0; i < currencyD.length; i++) {
        if (currencyD[i]['default'] == true) {
          this.setState({
            selectedCurrency: currencyD[i]['name'],
            selectedCurrencyID: currencyD[i]['id'],
            selectedCurrencyCODE: currencyD[i]['code'],
          });
          if (currencyD[i]['id'] == this.state.selectedCurrencyID) {
            let item = currencyD[i];
            this.setState({
              selectedCurrency: item['name'],
              selectedCurrencyID: item['id'],
              selectedCurrencyCODE: item['code'],
            });
          }
          this.state.currencyArray.push(currencyD[i]);
        }
      }
      this.setState({ updateUI: this.state.updateUI });
    }
    this.setState({ dataLoad: true });
  };
  loadCategoryApi = async () => {
    const responseJson = await networkService.networkCall(
      APPURL.URLPaths.categories + 'listings',
      'get',
    );
    this.setState({ categoriesArray: [] });
    if (responseJson['status'] == true) {
      var listD = responseJson['data']['categories'];
      for (let i = 0; i < listD.length; i++) {
        this.manageData(listD[i], listD[i]['name']);
        let hierarchyD = listD[i]['sub_category'];
        if (hierarchyD.length != 0) {
          for (let j = 0; j < hierarchyD.length; j++) {
            this.manageData(
              hierarchyD[j],
              `${listD[i]['name']}-> ${hierarchyD[j]['name']}`,
            );
            let hierarchy2 = hierarchyD[j]['sub_category'];
            if (hierarchy2.length != 0) {
              for (let k = 0; k < hierarchy2.length; k++) {
                this.manageData(
                  hierarchy2[k],
                  `${hierarchyD[j]['name']}--> ${hierarchy2[k]['name']}`,
                );
                let hierarchy3 = hierarchy2[k]['sub_category'];
                if (hierarchy3.length != 0) {
                  for (let l = 0; l < hierarchy3.length; l++) {
                    this.manageData(
                      hierarchy3[l],
                      `${hierarchy2[k]['name']}---> ${hierarchy3[l]['name']}`,
                    );
                  }
                }
              }
            }
          }
        }
      }
    }
    this.setState({ dateLoad: true });
  };
  manageData(data) {
    var deleteEnable = true;
    if (data['sub_category']) {
      deleteEnable = data['sub_category'].length == 0 ? true : false;
      if (data['sub_category'].length !== 0) {
        deleteEnable = data['parent'] == 0 ? false : true;
      }
    }
    let hierarchyAry = data['hierarchy'];
    var hierarchyName = '';
    if (hierarchyAry.length > 0) {
      for (let a = 0; a < hierarchyAry.length; a++) {
        hierarchyName = `${hierarchyName}${hierarchyAry[a]['name']}`;
        if (a !== hierarchyAry.length - 1) {
          hierarchyName = hierarchyName + ' -> ';
        }
      }
    }
    let catData = {
      id: data['id'],
      parent: data['parent'],
      name: data['name'],
      active: data['active'],
      image_path: data['image_path'],
      delete: deleteEnable,
      subCategory: data['name'],
      order_by: data['order_by'],
      hierarchyName: hierarchyName,
      label: hierarchyName,
      value: data['id'],
    };
    this.state.categoriesArray.push(catData);
  }
  loadAttributesApi = async id => {
    this.setState({ dataLoad: false });
    const responseJson = await networkService.networkCall(
      `${APPURL.URLPaths.attributes}/?category_id=${id}&type=listings`,
      'get',
      '',
      '',
    );
    this.setState({ attributesArray: [], attributes: [] });
    let storedAttributes = [];
    // if (localStorage.getItem('currentListingAttributes')) {
    //   storedAttributes = JSON.parse(
    //     localStorage.getItem('currentListingAttributes'),
    //   );
    // }

    if (responseJson['status'] == true) {
      var objData = responseJson['data']['attributes'];
      this.setState({ attributes: objData });
      // if (storedAttributes.length > 0) {
      //   let canBeAdded = storedAttributes.filter(attr => {
      //     return objData.some(storedAttr => storedAttr.id === attr.id);
      //   });
      //   this.setState({attributeData: canBeAdded});
      // }
    }
    this.setState({ dataLoad: true });
  };
  uploadImageAPI = async () => {
    try {
      const { imagesArray = [] } = this.state;
      const uploadDataParm = [];

      // Separate existing URLs from new images to upload
      const imagesToUpload = [];
      for (let i = 0; i < imagesArray.length; i++) {
        const img = imagesArray[i];
        if (!img) continue;

        const fileName = img?.name ?? img;
        const strFirstThree = String(fileName || '').substring(0, 4);

        if (strFirstThree === 'http' || (typeof img === 'string' && img.startsWith('http'))) {
          // Already a URL
          uploadDataParm.push(typeof img === 'string' ? img : img);
        } else {
          // New image to upload
          imagesToUpload.push(img);
        }
      }

      // Upload new images if any
      if (imagesToUpload.length > 0) {
        const uploadedUris = await uploadImageAPI({
          image_file: imagesToUpload,
          onProgress: (completed, total) => {
            // Optional progress tracking
          },
          onError: (error) => {
            console.error('S3 signed URL fetch failed:', error);
          }
        });

        if (uploadedUris && uploadedUris.length > 0) {
          uploadDataParm.push(...uploadedUris);
        }
      }

      // Proceed with the API call
      this.addListingsApi(uploadDataParm);
    } catch (error) {
      console.error('uploadImageAPI error:', error);
    }
  };

  addListingsApi = async parameter => {
    var dict = {
      list_price: Number(this.state.listPriceValue),
      currency_id: this.state.selectedCurrencyID,
      stock: Number(this.state.stockValue),
      title: this.state.titleString,
      order_type: this.props.isEdit
        ? this.state.order_type
        : this.props?.type || 'listings',
    };

    if (this.state.selectedAccount) {
      dict['account_id'] = this.state.selectedAccount?.id;
    }
    if (this.state.selectedCategoryID.length != 0) {
      dict['category_id'] = this.state.selectedCategoryID;
    }
    if (this.state.offerPercentage.length != 0) {
      dict['offer_percent'] = Number(this.state.offerPercentage);
    }
    if (this.state.descriptionString.length != 0) {
      dict['description'] = this.state.descriptionString;
    }
    if (this.state.metaTitle.length != 0) {
      dict['meta_title'] = this.state.metaTitle;
    }
    if (this.state.metaDescriptionString.length != 0) {
      dict['meta_description'] = this.state.metaDescriptionString;
    }
    if (this.state.selected_listing_tax) {
      dict['tax_ids'] = [this.state.selected_listing_tax?.id];
    }
    //set slug
    let slugValue =
      this.state.slugValue?.replace(/\s/g, '').length != 0
        ? this.state.slugValue
        : this.state.titleString;
    let vslug = slugChecker(slugValue);
    dict['slug'] = vslug;

    if (parameter.length != 0) {
      dict['images'] = parameter;
    }
    let attributeData = this.state.attributeData;
    let updated_attributes_data = attributeData?.length
      ? attributeData.find(attr => attr.uploadFile)
        ? await upload_attributes_files({
          all_attributes: attributeData,
          setIsLoading: this.setState({ isLoading: true }),
        })
        : attributeData
      : undefined;

    if (updated_attributes_data?.length > 0) {
      dict['attributes'] = updated_attributes_data;
    }
    if (this.state.tags?.length != 0) {
      dict['tags'] = this.state.tags;
    }
    if (this.state.maxQuantity?.length != 0) {
      dict['max_quantity'] = this.state.maxQuantity;
    }
    var method = 'post';
    var path = APPURL.URLPaths.listingsModerate;
    if (this.state.id != '') {
      path = `${APPURL.URLPaths.listingsModerate}/${this.state.id}`;
      method = 'PATCH';
    }
    const responseJson = await networkService.networkCall(
      path,
      method,
      JSON.stringify({ listing: dict }),
    );
    this.setState({ dataLoad: true });
    if (responseJson['status'] == true) {
      if (AppConstants.moduleType == ModuleType.event) {
        if (this.state.id != '') {
          this.scheduleAPI(this.state.id);
        } else {
          let dictData = responseJson['data']['listing'];
          this.scheduleAPI(dictData['id']);
        }
      } else if (
        this.state.digitalProducts?.content?.length > 0 &&
        (this.props?.type === 'digital' || this.state.order_type === 'digital')
      ) {
        await upload_digital_products({
          listingId: responseJson['data']['listing']['id'],
          digitalProducts: this.state.digitalProducts,
        });
        this.successResponse();
      } else {
        this.successResponse();
      }
    } else {
      this.mixpanelInfo(false);
      AppToast(responseJson);
    }
  };
  successResponse() {
    this.listingFormDraftSaved = true;
    clearListingDraft(this.listingFormDraftKey);
    this.mixpanelInfo(true);
    if (this.props.isEdit) {
      this.props.navigate(`/listing/${this.props.params.listingID}`);
    } else {
      this.props.navigate('/listings');
    }
    AppToast();
  }
  scheduleAPI = async id => {
    let uploadDic = [];
    for (let obj of this.state.scheduleArray) {
      let timeSlots = obj['timeSlots'];
      let scheduledate = changeDateFormat(obj['startDate'], 'yyyy-MM-DD');
      let repeat_days = obj['repeatClass']['ids'];
      for (let time of timeSlots) {
        let st = convertTimeinto24Hrs(time['start']);
        let et = convertTimeinto24Hrs(time['end']);
        var dic = {
          start_date: scheduledate,
          start_time: st,
          end_time: et,
          active: true,
          repeat_days: repeat_days.split(','),
          schedule_type: 2,
        };
        uploadDic.push(dic);
      }
    }

    var bodyPrm = '';
    if (uploadDic?.length != 0) {
      bodyPrm = JSON.stringify({ schedules: uploadDic });
    }
    let path = `${APPURL.URLPaths.listingsModerate}/${id}/${APPURL.URLPaths.schedules}`;
    const responseJson = await networkService.networkCall(path, 'PUT', bodyPrm);
    this.setState({ dataLoad: true });
    if (responseJson['status'] == true) {
      this.successResponse();
    } else {
      this.mixpanelInfo(false);
      AppToast(responseJson);
    }
  };

  mixpanelInfo(resp) {
    let properties = { success: resp };
    let event =
      this.state.id !== ''
        ? MixPannelEnum.editlistings
        : MixPannelEnum.addlistings;
    addMixpanelEvent(event, properties);
  }
  customAlert(msg) {
    this.setState({ dataLoad: true });
    AppToast(this.props.localeContext?.translate?.('listings.select_item', {item: msg}, 'Please select {item}') || `Please select ${msg}`);
  }
  //MARK:-  Button Actions
  submitBtnAction = id => {
    // validation with all conditions

    if (this.state.titleString?.length == 0) {
      AppToast(this.t('listings.title_required', 'Please enter a title'));
      return;
    }

    // if (!AppConstants.appType && this.state.selectedAccount == null) {
    //   AppToast('Please select account');
    //   return;
    // }

    if (
      this.state.listing_taxes?.length > 0 &&
      this.state.selected_listing_tax == null
    ) {
      AppToast(this.t('listings.select_tax', 'Please select a tax'));
      return;
    }

    this.state.saveAsDraft = id == 1 ? false : true;
    this.setState({ dataLoad: false });
    this.uploadImageAPI();
  };
  dropdownBtnAction(id) {
    this.state.showDropDown[id] = !this.state.showDropDown[id];
    this.setState({ updateUI: !this.state.updateUI });
  }
  didSelectCurrencyDropDown = item => {
    this.state.showDropDown[0] = !this.state.showDropDown[0];
    this.setState({
      selectedCurrency: item['name'],
      selectedCurrencyID: item['id'],
      selectedCurrencyCODE: item['code'],
    });
  };
  handleSelectChange = selectedOptions => {
    // see everytime when user change category than i wnat to store tha current  Attributes data in local storage and than make that empty
    // localStorage.setItem(
    //   'currentListingAttributes',
    //   JSON.stringify(this.state.attributeData),
    // );

    // Handle multiple categories
    const categoryIds = selectedOptions ? selectedOptions.map(option => option.id) : [];
    const categoryNames = selectedOptions ? selectedOptions.map(option => option.name).join(', ') : '';

    this.setState({
      attributeData: [],
      selectedCategory: categoryNames,
      selectedCategoryID: categoryIds,
    });
    this.state.selectedCategoryArray = selectedOptions || [];

    // Load attributes for all selected categories (comma-separated IDs)
    if (categoryIds.length > 0) {
      this.loadAttributesApi(categoryIds.join(','));
    }

    this.setState({ updateUI: !this.state.updateUI });
  };
  handleRefreshAttributes() {
    const categoryIds = Array.isArray(this.state.selectedCategoryID)
      ? this.state.selectedCategoryID.join(',')
      : this.state.selectedCategoryID || '';
    this.loadAttributesApi(categoryIds);
  }
  didSelectAttributeDropDown = item => {
    this.setState({ showAttributeDropDown: !this.state.showAttributeDropDown });
  };
  onHandleTextChange(text, id) {
    let value = text;
    if (id == 0) {
      if (text == '' || this.state.regexp.test(value)) {
        this.setState({ listPriceValue: text });
      }
    } else if (id == 1) {
      if (text == '' || this.state.regexp.test(value)) {
        this.setState({ offerPercentage: text });
      }
    } else if (id == 3) {
      if (text == '' || this.state.regexp.test(value)) {
        this.setState({ maxQuantity: text });
      }
    } else if (id == 5) {
      this.setState({ metaTitle: text });
    } else if (id == 6) {
      this.setState({ metaDescriptionString: text });
    } else {
      if (text == '' || this.state.regexp.test(value)) {
        this.setState({ stockValue: text });
      }
    }
  }

  offerPercentageEndEditing() {
    if (this.state.offerPercentage < 0 || this.state.offerPercentage > 100) {
      this.setState({ offerPercentage: '' });
      AppToast(this.t('listings.offer_percentage_validation', 'Offer percentage must be between 0 and 100'));
    }
  }
  onPick = acceptedFiles => {
    if (this.state.imagesArray?.length < this.state.pictureCount) {
      this.setState({
        imagesArray: [...this.state.imagesArray, ...acceptedFiles],
        updateUI: !this.state.updateUI,
      });
    } else {
      AppToast(this.t('listings.addon.image_limit', 'You cannot select more images'));
    }
  };
  showMediaBtnAction() {
    if (this.state.mediaArray != 0) {
      this.setState({ showMediaManager: true });
    } else {
      AppToast(this.t('listings.addon.no_media', 'You do not have any media files.'));
    }
  }
  deleteImageButtonAction(id) {
    this.state.imagesArray.splice(id, 1);
    this.setState({ updateUI: !this.state.updateUI });
  }
  onTagsChanged(tags) {
    this.setState({ tags });
  }
  onValuesTagChanged(tags, index, id, type) {
    this.state.selectedAttributeArray[index] = { tags: tags, id: id, type: type };
    this.setState({ updateUI: this.state.updateUI });
  }
  handleAttributesChange = (selectedOption, index, type) => {
    if (type == 2) {
      if (selectedOption != undefined) {
        if (selectedOption[0]) {
          let dict = {
            type: type,
            id: selectedOption[0]['id'],
            value: selectedOption,
          };
          this.state.selectedAttributeArray[index] = dict;
        } else {
          let dict = { type: type, id: '', value: [] };
          this.state.selectedAttributeArray[index] = dict;
        }
      }
    } else {
      this.state.selectedAttributeArray[index] = selectedOption;
    }
    this.setState({ updateUI: this.state.updateUI });
  };
  valueFieldsChanged(text, index, id, type) {
    if (type == 7) {
      this.state.startDate = text;
      let dtm = Moment(this.state.startDate).format(dateFormat);
      this.state.selectedAttributeArray[index] = {
        value: dtm,
        id: id,
        type: type,
      };
    } else {
      this.state.selectedAttributeArray[index] = {
        value: text,
        id: id,
        type: type,
      };
    }
    this.setState({ updateUI: this.state.updateUI });
  }
  onPickAttachment = (image, index, id, type) => {
    this.state.selectedAttributeArray[index] = {
      image: image,
      id: id,
      type: type,
    };
    this.setState({ updateUI: this.state.updateUI });
  };
  onMediaAttachment = (index, id) => {
    if (this.state.mediaArray != 0) {
      this.state.attributeImageID = id;
      this.state.attributeImageIndex = index;
      this.setState({ showMediaManager: true });
    } else {
      AppToast(this.t('listings.addon.no_media', 'You do not have any media files.'));
    }
  };
  didSelectMediaManager(path) {
    if (this.state.attributeImageIndex != -1) {
      this.state.selectedAttributeArray[this.state.attributeImageIndex] = {
        image: path,
        id: this.state.attributeImageID,
        type: 5,
      };
    } else {
      this.state.imagesArray.push(path);
    }
    this.setState({ showMediaManager: false, attributeImageIndex: -1 });
  }
  onHandleNumberFieldChange(text, index, id, type) {
    let value = text;
    if (text == '' || this.state.regexp.test(value)) {
      this.state.selectedAttributeArray[index] = {
        value: text,
        id: id,
        type: type,
      };
      this.setState({ updateUI: this.state.updateUI });
    }
  }
  handleChangeComplete(color, index, id, type) {
    if (Platform.OS === 'web') {
      this.state.selectedAttributeArray[index] = {
        value: color['hex'],
        id: id,
        type: type,
      };
      this.state.showColorPicker = [];
      this.setState({ updateUI: this.state.updateUI });
    }
  }
  handleChangeLocation(lat, lng) {
    let dic = { latitude: lat, longitude: lng };
    let id_Index = this.state.selectedAttributeArray.findIndex(
      x => x.type === 12,
    );
    if (id_Index != -1) {
      this.state.selectedAttributeArray[id_Index] = {
        value: dic,
        id: this.state.selectedAttributeArray[id_Index]['id'],
        type: 12,
      };
    }
    this.setState({ latitude: lat, longitude: lng, showMapView: false });
  }
  jsonFilePickAction(json, index, id, type) {
    var b64 = json['base64'];
    b64 = b64.replace('data:application/json;base64,', '');
    var decodedStr = this.base64DecodeUnicode(b64);
    this.state.selectedAttributeArray[index] = {
      value: decodedStr,
      id: id,
      type: type,
    };
    this.setState({ updateUI: this.state.updateUI });
  }
  base64DecodeUnicode(str) {
    let percentEncodedStr = atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('');

    return decodeURIComponent(percentEncodedStr);
  }
  showColorPickerBtnAction(id) {
    this.state.showColorPicker.push(id);
    this.setState({ updateUI: this.state.updateUI });
  }
  didSelectRepeat = index => {
    this.setState({ showScheduleRepeatBool: false, selectedRepeatIndex: index });
  };
  didSelectWeekdays(item) {
    let ind = this.state.selectedWeekDay.findIndex(x => x.id == item.id);
    if (ind == -1) {
      this.state.selectedWeekDay.push(item);
    } else {
      this.state.selectedWeekDay.splice(ind, 1);
    }
    this.setState({ updateUI: !this.state.updateUI });
  }

  openTimePicker(index) {
    if (index == 0) {
      this.state.showTimeBool = [!this.state.showTimeBool[index], false];
    } else {
      this.state.showTimeBool = [false, !this.state.showTimeBool[index]];
    }
    this.setState({ updateUI: !this.state.updateUI });
  }
  didSelectSlot = item => {
    this.setState({ selectedSlot: item, showSlotBool: false });
  };
  didSelectDate(date, id) {
    // if (id == 2) {
    //   if (this.state.scheduleStartDate <= date){
    //     this.setState({ scheduleEndDate: date })
    //   }else {
    //     AppToast('End date must be greater then start date')
    //   }
    // } else {
    //   if (this.state.scheduleEndDate >= date){
    this.setState({ scheduleStartDate: date });
    // }else {
    //   AppToast('Start date must be less then end date')
    // }
    // }
  }
  didSelectStartTime(item) {
    var beginningTime = Moment(item, 'hh:mm a');
    var endTime = Moment(this.state.scheduleEndTime, 'hh:mm a');
    if (beginningTime.isBefore(endTime)) {
      this.state.showTimeBool[0] = !this.state.showTimeBool[0];
      this.setState({ scheduleStartTime: item });
    } else {
      AppToast(this.t('listings.schedule.start_time_before_end', 'Start time must be before the end time'));
    }
  }
  didSelectEndTime(item) {
    var beginningTime = Moment(item, 'hh:mm a');
    var endTime = Moment(this.state.scheduleStartTime, 'hh:mm a');
    if (beginningTime.isAfter(endTime)) {
      this.state.showTimeBool[1] = !this.state.showTimeBool[1];
      this.setState({ scheduleEndTime: item });
    } else {
      AppToast(this.t('listings.schedule.end_time_after_start', 'End time must be after the start time'));
    }
  }
  saveScheduleBtnAction() {
    if (this.state.selectedRepeatIndex == -1) {
      AppToast(this.t('listings.schedule.repeat_required', 'Select a repeat pattern'));
    } else {
      var repeatValue =
        ConstantArray.repeatArray[this.state.selectedRepeatIndex]['name'];
      var repeatIds =
        ConstantArray.repeatArray[this.state.selectedRepeatIndex]['id'];
      if (repeatIds == '') {
        var idsary = [];
        var namesary = [];
        for (let obj of this.state.selectedWeekDay) {
          idsary.push(obj['id']);
          namesary.push(obj['name']);
        }
        repeatIds = idsary.toString();
        repeatValue = namesary.toString();
      }
      let reactDic = {
        name: repeatValue,
        ids: repeatIds,
      };
      let timeSlots = getTimeDifferenceArray(
        this.state.scheduleStartTime,
        this.state.scheduleEndTime,
        this.state.selectedSlot,
      );
      let dict = {
        startDate: this.state.scheduleStartDate,
        startTime: this.state.scheduleStartTime,
        endTime: this.state.scheduleEndTime,
        slot: this.state.selectedSlot,
        repeatClass: reactDic,
        timeSlots: timeSlots,
      };
      this.state.scheduleArray.push(dict);
      this.setState({ showAddScheduleViewBool: false });
      // this.scheduleAPI(0)
    }
  }
  deleteScheduleItem(index) {
    this.state.scheduleArray.splice(index, 1);
    this.setState({ updateUI: !this.state.updateUI });
  }
  addScheduleBtnAction() {
    this.state.scheduleStartDate = new Date();
    this.state.selectedRepeatIndex = -1;
    this.state.selectedWeekDay = [];
    this.state.scheduleStartTime = '09:00 am';
    this.state.scheduleEndTime = '05:00 pm';
    this.state.selectedSlot = slotArray[3]['name'];
    this.setState({ showAddScheduleViewBool: true });
  }

  // UI Renders
  imageViewPicker = props => {
    let imageCount = this.state.imagesArray?.length;
    var msgTxt = '';
    if (imageCount == 3) {
      msgTxt = '3 files added';
    } else {
      msgTxt =
        imageCount == 0
          ? 'Choose file or Drag and drop here'
          : imageCount + ' file added';
    }
    return (
      <View style={appConfigStyle.dottedViewStyle}>
        <FilePicker data={files => this.onPick(files)} />
      </View>
    );
  };
  renderListingImageView = () => {
    if (this.state.pictureCount > 0) {
      return (
        <View style={{ width: '100%', alignItems: 'flex-start', marginTop: 5 }}>
          <View style={{ height: 20 }} />
          <Text style={CommonStyleSheet.plainTextStyle}>
            {this.t('listings.image_optional', 'Listing Images (Optional)')}
          </Text>
          <View style={styles.firstViewStyle}>
            <ScrollView horizontal={true}>
              <View
                style={{
                  width: '100%',
                  flexDirection: 'row-reverse',
                  margin: 10,
                }}>
                {this.viewSelectedImages()}
              </View>
            </ScrollView>
          </View>
        </View>
      );
    } else {
      return <View />;
    }
  };
  viewSelectedImages = () => {
    var views = [];
    for (let i = 0; i < this.state.imagesArray?.length + 1; i++) {
      let imageObj = {};
      if (this.state.imagesArray[i]) {
        imageObj = this.state.imagesArray[i];
      }
      if (JSON.stringify(imageObj) !== '{}') {
        let fileName = imageObj['name'] ?? null;
        var showImage = true;
        var icon = jsonIcon;
        var fileExt = '';
        if (fileName == null) {
          let name = imageObj.substring(imageObj.lastIndexOf('/') + 1);
          var fileExt = name.split('.').pop();
        } else {
          let name = imageObj['name'].replace(/ /g, '');
          fileExt = name.split('.').pop();
        }
        if (fileExt == 'json') {
          icon = jsonIcon;
          showImage = false;
        } else if (fileExt == 'pdf') {
          icon = pdfIcon;
          showImage = false;
        }
        views.push(
          <View>
            <View style={styles.imageSelectedStyle}>
              <View>
                <Image
                  source={
                    showImage
                      ? { uri: fileName == null ? imageObj : imageObj['base64'] }
                      : icon
                  }
                  style={styles.SelectedImageStyle}
                />
                <TouchableOpacity
                  style={styles.deleteViewStyle}
                  onPress={() => this.deleteImageButtonAction(i)}>
                  <Image
                    resizeMode={'center'}
                    style={styles.deleteImageStyle}
                    source={blackCrossIcon}
                  />
                </TouchableOpacity>
              </View>
            </View>
          </View>,
        );
      } else if (this.state.imagesArray?.length >= this.state.pictureCount) {
        views.push(<View />);
      } else {
        views.push(
          <View>
            <View style={{ flexDirection: 'row' }}>
              <View style={styles.imagePickerPlaceholderStyle}>
                {/* <ReactFileReader
                  fileTypes={['.gif', '.json', '.pdf', 'image/*',]}
                  base64={true}
                  handleFiles={img => this.onPick(img, i)}>
                  <View style={{ justifyContent: 'center' }}>
                    <Image source={upload_Icon} style={{ width: 30, height: 30, alignSelf: 'center' }} />
                    <Text style={commonStyle.uploadHereTextStyle}>{this.t('listings.upload_here', 'Upload here')}</Text>
                  </View>
                </ReactFileReader> */}
                <FilePicker
                  style={[
                    commonStyle.uploadHereTextStyle,
                    { paddingTop: 30, height: 100, textAlign: 'center' },
                  ]}
                  title={this.t('listings.upload_here', 'Upload here')}
                  data={files => this.onPick(files, i)}
                />
              </View>
              <View style={{ width: 20, height: 20 }} />
              <View style={styles.imagePickerPlaceholderStyle}>
                <TouchableOpacity
                  style={{ width: 100 }}
                  onPress={() => this.showMediaBtnAction()}>
                  <Text
                    style={[commonStyle.uploadHereTextStyle, { marginTop: 0 }]}>
                    {this.t('listings.select_from_media', 'Select from media')}
                  </Text>
                </TouchableOpacity>
              </View>
              <View style={{ width: 20, height: 20 }} />
            </View>
          </View>,
        );
      }
    }
    return views;
  };

  customDropDown = id => {
    let index = id['id'];
    if (this.state.showDropDown[index] == true) {
      let dAray =
        index == 0 ? this.state.currencyArray : this.state.categoriesArray;
      return (
        <View style={commonStyle.showDropDownViewStyle}>
          <FlatList
            data={dAray}
            horizontal={false}
            renderItem={
              index == 0 ? this.renderDropDown : this.renderCategoryDropDown
            }
            extraData={this.state}
            showsVerticalScrollIndicator={true}
            scrollEnabled={true}
            keyExtractor={(item, index) => index + 912799}
            key={'D'}
          />
        </View>
      );
    }
    return <View></View>;
  };
  renderDropDown = ({ item, index }) => {
    return (
      <TouchableOpacity
        onPress={() => this.didSelectCurrencyDropDown(item, index)}
        style={{ margin: 5, height: 30, marginBottom: 5 }}>
        <View style={{ justifyContent: 'center', width: '100%', padding: 5 }}>
          <Text style={CommonStyleSheet.plainSubTextStyle}>{item['name']}</Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderCategoryDropDown = ({ item, index }) => {
    return (
      <TouchableOpacity
        onPress={() => this.didSelectCategoryDropDown(item, index)}
        style={{ margin: 5, height: 30, marginBottom: 5 }}>
        <View style={{ justifyContent: 'center', width: '100%' }}>
          <Text style={CommonStyleSheet.plainSubTextStyle}>{item['name']}</Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderValueLabel = id => {
    let index = id['id'];
    let textValue =
      index == 0 ? this.state.selectedCurrency : this.state.selectedCategory;
    let placeholder = index == 0 ? this.t('listings.select_currency', 'Select currency') : this.t('listings.select_category', 'Select category');
    var views = [];
    views.push(
      <Image
        style={
          this.state.showDropDown[index] == true
            ? appConfigStyle.upArraowIconStyle
            : appConfigStyle.downArraowIconStyle
        }
        resizeMode="contain"
        source={downArrow_Icon}
      />,
    );
    return (
      <View style={styles.dropdownLabelStyle}>
        <Text
          style={
            textValue == ''
              ? appConfigStyle.placeholderTxtStyle
              : appConfigStyle.txtFieldStyleDropDown
          }>
          {textValue == '' ? placeholder : textValue}
        </Text>
        {views}
      </View>
    );
  };
  renderTitleLbl = ({ title }) => {
    return (
      <View style={{ margin: -5 }}>
        <Text style={CommonStyleSheet.plainSubTextStyle}>
          {' '}
          {title}
          <Text style={{ color: colors.AppRed, paddingTop: 5 }}> *</Text>
        </Text>
      </View>
    );
  };
  renderAttributeLableView = item => {
    var titleAray = [];
    var toolTipView = [];
    if (item['tooltip']) {
      if (item['tooltip']?.length != 0) {
        toolTipView.push(
          <View style={{ marginLeft: 10 }}>
            <ToolTipViewBtn
              title={item['name']}
              description={item['tooltip']}
            />
          </View>,
        );
      }
    }
    if (item['optional'] == false) {
      titleAray.push(
        <View style={{ flexDirection: 'row', alignItems: 'center', zIndex: 191 }}>
          {this.renderTitleLbl({ title: item['name'] })}
          {toolTipView}
        </View>,
      );
    } else {
      titleAray.push(
        <View style={{ flexDirection: 'row', zIndex: 191, alignItems: 'center' }}>
          <Text style={CommonStyleSheet.plainSubTextStyle}>{item['name']}</Text>
          {toolTipView}
        </View>,
      );
    }
    return titleAray;
  };
  renderArttributes = () => {
    return this.state.attributes?.length > 0 ? (
      <View style={[styles.firstViewStyle, { zIndex: 10 }]}>
        <View style={{ margin: 16 }}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
            }}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
              }}>
              <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.attributes', 'Attributes')}</Text>
              <TouchableOpacity
                style={{ marginLeft: '10px' }}
                onPress={() => this.handleRefreshAttributes()}>
                <RefreshIcon style={{ height: 15, width: 15 }} />
              </TouchableOpacity>
            </View>
            <Text
              style={appConfigStyle.titleTxtStyle}
              onPress={() => window.open('/listing-attributes', '_blank')}>{this.t('listings.add_attribute', 'Add Attribute')}</Text>
          </View>
        </View>
        <View style={{ margin: 16, marginTop: 8 }}>
          <Attributes
            attributeData={this.state.attributeData}
            setAttributeData={value => this.setState({ attributeData: value })}
            attributes={this.state.attributes}
          />
        </View>
      </View>
    ) : (
      <></>
    );
  };

  renderStockView = () => {
    if (this.state.showStock) {
      return (
        <View style={appConfigStyle.listingTxtFieldContainerStyle}>
          <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.stock', 'Stock')}</Text>
          <TextInput
            style={[appConfigStyle.listingTextFieldStyle, { outline: 0 }]}
            placeholder={this.t('listings.enter_stock', 'Enter Stock')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.onHandleTextChange(text, 2)}
            value={this.state.stockValue}
          />
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderOfferView = () => {
    if (this.state.showOffer) {
      return (
        <View style={appConfigStyle.listingTxtFieldContainerStyle}>
          <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.offer_percentage', 'Offer Percentage')}</Text>
          <TextInput
            style={[appConfigStyle.listingTextFieldStyle, { outline: 0 }]}
            placeholder={this.t('listings.enter_offer', 'Enter offer')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.onHandleTextChange(text, 1)}
            value={this.state.offerPercentage}
            onBlur={() => this.offerPercentageEndEditing()}
          />
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderMaxQntyView = () => {
    if (this.state.showMAxQty) {
      return (
        <View style={appConfigStyle.listingTxtFieldContainerStyle}>
          <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.max_quantity_optional', 'Max quantity (optional)')}</Text>
          <TextInput
            style={[appConfigStyle.listingTextFieldStyle, { outline: 0 }]}
            placeholder={this.t('listings.enter_max_quantity', 'Enter Max Quantity')}
            placeholderTextColor={colors.placeholderColor}
            onChangeText={text => this.onHandleTextChange(text, 3)}
            value={this.state.maxQuantity}
          />
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderTagView = () => {
    if (this.state.showTag) {
      return (
        <View style={{ width: '100%', alignItems: 'flex-start' }}>
          <Text style={CommonStyleSheet.plainTextStyle}>{this.t('listings.tags', 'Tags')}</Text>
          <View style={styles.firstViewStyle}>
            <View style={{ height: 150, padding: 16 }}>
              <TagsInput
                value={this.state.tags}
                addKeys={[188, 9, 13]}
                addOnPaste={true}
                pasteSplit={data => {
                  const separators = [
                    ',',
                    ';',
                    '\\(',
                    '\\)',
                    '\\*',
                    '/',
                    ':',
                    '\\?',
                    '\n',
                    '\r',
                  ];
                  return data
                    .split(new RegExp(separators.join('|')))
                    .map(d => d.trim());
                }}
                onChange={txt => this.onTagsChanged(txt)}
              />
            </View>
          </View>
          <View style={{ height: 20 }} />
        </View>
      );
    } else {
      return <View />;
    }
  };
  onChangeDescription(txt) {
    this.setState({ descriptionString: txt });
  }
  renderDescriptionView = () => {
    return (
      <View>
        {/* <Text style={appConfigStyle.titleTxtStyle}>Description </Text> */}
        <DescriptionView
          value={this.state.descriptionString}
          onChange={txt => this.onChangeDescription(txt)}
        />

        {/* make thsi as absolute view on top of the description view */}
        <View
          style={{
            position: 'absolute',
            top: 18,
            right: 15,
            bottom: 0,
            zIndex: 1000,
            height: 40,
            width: 24,
            backgroundColor: 'var(--color-input)',
          }}>
          <GenerateText
            system_instruction={instructions.listing_description.system}
            user_id={AppConstants.userId}
            user_message={replacePlaceholders({
              template: instructions.listing_description.user,
              data: {
                title: this.state.titleString,
              },
            })}
            openSide="right"
            disabled={!this.state.titleString}
            onDisabledAlert={() =>
              ToastPopup({
                type: 'error',
                message: this.t('listings.title_required', 'Please enter a title first'),
              })
            }
            isShowCopyButton={true}
            type={'listing_description'}
          />
        </View>
      </View>
    );
  };
  mediaManagerView = () => {
    return (
      <TradlyMediaPicker
        onSelect={url => {
          this.setState({ showMediaManager: false, selectedImage: url });
        }}
        options={['image']}
        isOpen={this.state.showMediaManager}
        onClose={() => this.setState({ showMediaManager: false })}
      />
    );
  };
  renderCurrencyView = () => {
    if (this.state.currencyArray?.length >= 1) {
      return (
        <View style={{ margin: 16 }}>
          <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.currency', 'Currency')}</Text>
          <TouchableOpacity
            style={[styles.dropDownViewStyle, { borderWidth: 1 }]}
            onPress={() => this.dropdownBtnAction(0)}>
            <this.renderValueLabel id={0} />
            <this.customDropDown id={0} />
          </TouchableOpacity>
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderMapView = () => {
    if (this.state.showMapView) {
      return (
        <View style={styles.mapViewContainerStyle}>
          <MapPicker
            defaultLocation={DefaultLocation}
            zoom={DefaultZoom}
            mapTypeId="roadmap"
            style={{ height: '700px', width: '50%' }}
            onChangeLocation={(lat, lng) => this.handleChangeLocation(lat, lng)}
            apiKey={AppConstants.googleMapAPIKey}
          />
        </View>
      );
    } else {
      return <View />;
    }
  };
  renderSlugField = () => {
    return (
      <View style={styles.marginStyleView}>
        {/* <Text style={appConfigStyle.titleTxtStyle}>Slug</Text> */}
        <TextInput
          style={[appConfigStyle.txtFieldStyle, { outline: 0 }]}
          placeholder={this.t('listings.enter_slug', 'Enter slug')}
          placeholderTextColor={colors.placeholderColor}
          onChangeText={txt => this.setState({ slugValue: txt })}
          value={this.state.slugValue}
        />
      </View>
    );
  };
  renderMetaData = () => {
    return (
      <View
        style={{
          width: '100%',
          display:
            this.state.showMetaTitle || this.state.showMetaDescription
              ? 'flex'
              : 'none',
        }}>
        <Text style={CommonStyleSheet.plainTextStyle}>{this.t('listings.custom_seo', 'Custom SEO')}</Text>
        <View style={[styles.firstViewStyle]}>
          <View
            style={[
              styles.marginStyleView,
              { display: this.state.showMetaTitle ? 'flex' : 'none' },
            ]}>
            {/* <Text style={appConfigStyle.titleTxtStyle}>Meta Title</Text> */}
            <TextInput
              style={[appConfigStyle.txtFieldStyle, { outline: 0 }]}
              placeholder={this.t('listings.enter_meta_title', 'Enter meta title')}
              placeholderTextColor={colors.placeholderColor}
              onChangeText={txt => this.onHandleTextChange(txt, 5)}
              value={this.state.metaTitle}
            />
          </View>
          <View
            style={[
              styles.marginStyleView,
              {
                marginBottom: 16,
                display: this.state.showMetaDescription ? 'flex' : 'none',
              },
            ]}>
            {/* <Text style={appConfigStyle.titleTxtStyle}>Meta Description</Text> */}
            <DescriptionView
              value={this.state.metaDescriptionString}
              onChange={txt => this.onHandleTextChange(txt, 6)}
            />
          </View>
        </View>
      </View>
    );
  };
  renderPreviewView = () => {
    var imageViews = [];
    for (let i = 0; i < this.state.imagesArray.length + 1; i++) {
      let imageObj = {};
      if (this.state.imagesArray[i]) {
        imageObj = this.state.imagesArray[i];
      }
      if (JSON.stringify(imageObj) !== '{}') {
        let fileName = imageObj['image'] ?? null;
        var showImage = true;
        var icon = jsonIcon;
        var fileExt = '';
        if (fileName == null) {
          let name = imageObj.substring(imageObj.lastIndexOf('/') + 1);
          var fileExt = name.split('.').pop();
        } else {
          let name = imageObj['name'].replace(/ /g, '');
          fileExt = name.split('.').pop();
        }
        if (fileExt == 'json') {
          icon = jsonIcon;
          showImage = false;
        } else if (fileExt == 'pdf') {
          icon = pdfIcon;
          showImage = false;
        }
        imageViews.push(
          <View>
            <Image
              source={
                showImage
                  ? { uri: fileName == null ? imageObj : imageObj['image'] }
                  : icon
              }
              style={previewStyleSheet.previewImageStyle}
            />
          </View>,
        );
      }
    }
    let ticket =
      this.state.stockValue.length == 0 ? '' : `Only ${this.state.stockValue}`;
    let price =
      this.state.listPriceValue.length == 0
        ? ''
        : `${this.state.selectedCurrencyCODE} ${this.state.listPriceValue}`;
    var descpView = [];
    if (this.state.descriptionString.length != 0) {
      descpView.push(
        <View style={previewStyleSheet.commonPreviewStyle}>
          <Text style={previewStyleSheet.previewsubTitleStyle}>
            {this.state.descriptionString}
          </Text>
        </View>,
      );
    }

    return (
      <View style={{ width: 320, height: '70%' }}>
        <View style={{ flexDirection: 'column' }}>
          <View style={{ flexDirection: 'row', justifyContent: 'center' }}>
            <Text style={tableStyle.listTitleText}>{this.t('listings.preview', 'Preview')}</Text>
          </View>
          <View style={previewStyleSheet.previewFrameStyle}>
            <View style={{ justifyContent: 'center' }}>
              <ScrollView
                horizontal={true}
                showsHorizontalScrollIndicator={false}>
                <View
                  style={{ flexDirection: 'row', width: '100%', height: 260 }}>
                  {imageViews}
                </View>
              </ScrollView>
              <View style={previewStyleSheet.commonPreviewStyle}>
                <Text style={previewStyleSheet.previewTitleStyle}>
                  {this.state.titleString}
                </Text>
                <View style={{ height: 5 }} />
                <Text style={previewStyleSheet.previewTitleStyle}>{price}</Text>
                <View style={{ height: 5 }} />
                <Text
                  style={[
                    CommonStyleSheet.helperTextStyle,
                    { color: colors.AppNewGreen },
                  ]}>
                  {ticket}
                </Text>
              </View>
              <View style={{ height: 10 }} />
              {descpView}
              <View style={{ height: 10 }} />
            </View>
          </View>
        </View>
      </View>
    );
  };
  renderScheduleView = () => {
    var scheduleView = [];
    var display = 'none';
    for (let a = 0; a < this.state.scheduleArray.length; a++) {
      display = 'flex';
      let item = this.state.scheduleArray[a];
      let date = Moment(item['startDate']).format('ddd MMM Do YYYY');
      let repeat = translateRepeatSchedule(item['repeatClass']?.['ids'], this.t);
      let timeSlots = item['timeSlots']; //getTimeDifferenceArray(item['startTime'],item['endTime'],item['slot'])
      var slotsView = [];
      for (let objc of timeSlots) {
        slotsView.push(
          <Text
            style={[
              CommonStyleSheet.subTitleStyle,
              { color: 'gray', marginBottom: 5 },
            ]}>{`${objc['start']} ${objc['end']}`}</Text>,
        );
      }
      scheduleView.push(
        <View
          style={{
            flexDirection: 'row',
            borderRadius: 5,
            borderWidth: 1,
            borderColor: colors.SimonGray,
            margin: 16,
            padding: 5,
          }}>
          <View style={{ width: 30, alignItems: 'center' }}>
            <Image style={{ width: 30, height: 30 }} source={calendarIcon} />
          </View>
          <View style={{ flex: 1, marginLeft: 10 }}>
            <Text style={commonStyle.plainSubTextStyle}>
              {this.t('listings.starts_from', 'Starts from:')}{' '}
              <Text style={commonStyle.plainSubTextStyle}>{date}</Text>
            </Text>
            <View style={{ height: 10 }} />
            {slotsView}
            {/* <View style={{ height: 5 }} /> */}
            <Text style={commonStyle.plainSubTextStyle}>{repeat}</Text>
          </View>
          <View style={{ width: 30, alignItems: 'center' }}>
            <TouchableOpacity onPress={() => this.deleteScheduleItem(a)}>
              <Image style={{ width: 16, height: 20 }} source={deleteIcon} />
            </TouchableOpacity>
          </View>
        </View>,
      );
    }
    return (
      <View style={[styles.firstViewStyle, { zIndex: 10, display: display }]}>
        {scheduleView}
      </View>
    );
  };
  renderAddScheduleBtn = () => {
    return (
      <View style={[styles.firstViewStyle, { borderWidth: 0 }]}>
        <View style={tableStyle.secondButtonViewStyle}>
          <TouchableOpacity onPress={() => this.addScheduleBtnAction()}>
            <Text style={tableStyle.secondBtnTextStyle}>
              {this.t('listings.add_schedule', '+ Add schedule')}
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    );
  };
  renderSaveScheduleBtn = () => {
    return (
      <View style={[tableStyle.gradientViewBGStyle, { marginRight: 0 }]}>
        <Gradient
          gradients={colors.GradientColors} // required
          property="background"
          gradientType={'linear'}
          duration={2333000}
          angle="0deg">
          <TouchableOpacity onPress={() => this.saveScheduleBtnAction()}>
            <Text style={tableStyle.saveBtnTxtStyle}>{this.t('listings.save', 'Save')}</Text>
          </TouchableOpacity>
        </Gradient>
      </View>
    );
  };
  renderweekDays = () => {
    var weekView = [];
    for (let a = 0; a < ConstantArray.weekDays.length; a++) {
      let week = ConstantArray.weekDays[a];
      let ind = this.state.selectedWeekDay.findIndex(x => x.id == a + 1);
      let check = ind != -1 ? true : false;
      weekView.push(
        <TouchableOpacity
          style={check ? styles.weekdaysStyle : styles.selectedWeekdaysStyle}
          onPress={() => this.didSelectWeekdays(week)}>
          <Text
            style={[
              CommonStyleSheet.subTitleStyle,
              { color: 'var(--color-text)' },
            ]}>
            {translateWeekday(week.id, this.t)}
          </Text>
        </TouchableOpacity>,
      );
    }
    return <View style={styles.weekendViewStyle}>{weekView}</View>;
  };
  renderRepeatView = id => {
    let repVl = this.state.selectedRepeatIndex;
    return (
      <View>
        <View style={{ zIndex: 1001 }}>
          <Text style={commonStyle.scheduleTxtStyle}>{this.t('listings.repeat', 'Repeat')}</Text>
          <TouchableOpacity
            style={[styles.dropDownViewStyle, { marginTop: 5 }]}
            onPress={() =>
              this.setState({
                showScheduleRepeatBool: !this.state.showScheduleRepeatBool,
              })
            }>
            <this.renderRepeatValueLabel />
            <this.customRepeatDropDown />
          </TouchableOpacity>
        </View>
        <View
          style={{
            display: repVl == 3 ? 'flex' : 'none',
            zIndex: 101,
            marginTop: 10,
          }}>
          {this.renderweekDays()}
        </View>
      </View>
    );
  };
  renderRepeatValueLabel = () => {
    let repeatValue =
      this.state.selectedRepeatIndex == -1
        ? this.t('listings.select_value', 'Select value')
        : translateRepeatOption(
          ConstantArray.repeatArray[this.state.selectedRepeatIndex]['id'],
          this.t,
        );
    return (
      <View
        style={{
          width: '100%',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}>
        <Text
          style={
            this.state.selectedRepeatIndex == -1
              ? [commonStyle.placeholderTxtStyle, { outline: 0 }]
              : [
                commonStyle.placeholderTxtStyle,
                { outline: 0, color: 'var(--color-text)' },
              ]
          }>
          {repeatValue}
        </Text>
        <Image
          style={
            this.state.showScheduleRepeatBool == true
              ? commonStyle.upArraowIconStyle
              : commonStyle.downArraowIconStyle
          }
          resizeMode="contain"
          source={downArrow_Icon}
        />
      </View>
    );
  };
  customRepeatDropDown = id => {
    if (this.state.showScheduleRepeatBool == true) {
      return (
        <View style={commonStyle.showDropDownViewStyle}>
          <FlatList
            data={ConstantArray.repeatArray}
            horizontal={false}
            renderItem={this.renderRepeatDropDownCell}
            extraData={this.state}
            showsVerticalScrollIndicator={false}
            scrollEnabled={true}
          />
        </View>
      );
    }
    return <View></View>;
  };
  renderRepeatDropDownCell = ({ item, index }) => {
    return (
      <TouchableOpacity
        onPress={() => this.didSelectRepeat(index)}
        style={{ margin: 5, height: 30, marginBottom: 5 }}>
        <View style={{ justifyContent: 'center', width: '100%' }}>
          <Text style={commonStyle.dropdownCellItemTextStyle}>
            {translateRepeatOption(item['id'], this.t)}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderSlotLable = id => {
    let placeholder = 'Slot';
    let textValue = this.state.selectedSlot;
    var views = [];
    views.push(
      <Image
        style={
          this.state.showSlotBool == true
            ? appConfigStyle.upArraowIconStyle
            : appConfigStyle.downArraowIconStyle
        }
        resizeMode="contain"
        source={downArrow_Icon}
      />,
    );
    return (
      <View style={styles.dropdownLabelStyle}>
        <Text
          style={
            textValue == ''
              ? [
                appConfigStyle.placeholderTxtStyle,
                CommonStyleSheet.subTitleStyle,
                { marginLeft: 0 },
              ]
              : commonStyle.scheduleTxtStyle
          }>
          {textValue == '' ? placeholder : textValue}
        </Text>
        {views}
      </View>
    );
  };
  renderSlotDropDown = id => {
    if (this.state.showSlotBool == true) {
      return (
        <View
          style={[
            commonStyle.showDropDownViewStyle,
            { marginLeft: -10, marginTop: 28, height: 200 },
          ]}>
          <FlatList
            data={slotArray}
            horizontal={false}
            renderItem={this.renderSlotDropDownCell}
            extraData={this.state}
            scrollEnabled={true}
          />
        </View>
      );
    }
    return <View></View>;
  };
  renderSlotDropDownCell = ({ item, index }) => {
    return (
      <TouchableOpacity
        onPress={() => this.didSelectSlot(item['name'])}
        style={{ margin: 5, height: 30, marginBottom: 5 }}>
        <View style={{ justifyContent: 'center', width: '100%' }}>
          <Text style={commonStyle.dropdownCellItemTextStyle}>
            {item['name']}
          </Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderTimeDropDown = ({ id }) => {
    let timeArray = getTimeArray();
    if (this.state.showTimeBool[id] == true) {
      return (
        <View
          style={[
            commonStyle.showDropDownViewStyle,
            { marginLeft: 0, marginTop: 0 },
          ]}>
          <FlatList
            data={timeArray}
            horizontal={false}
            renderItem={this.renderTimeDropDownItem}
            extraData={this.state}
            scrollEnabled={true}
          />
        </View>
      );
    }
    return <View></View>;
  };
  renderTimeDropDownItem = ({ item, index }) => {
    let check = this.state.showTimeBool.findIndex(x => x == true);
    return (
      <TouchableOpacity
        onPress={() =>
          check == 1
            ? this.didSelectEndTime(item)
            : this.didSelectStartTime(item)
        }
        style={{ margin: 5, height: 30, marginBottom: 5 }}>
        <View style={{ justifyContent: 'center', width: '100%' }}>
          <Text style={commonStyle.dropdownCellItemTextStyle}>{item}</Text>
        </View>
      </TouchableOpacity>
    );
  };
  renderAddScheduleView = () => {
    let scheduleDate = Moment(this.state.scheduleStartDate).format(
      'DD-MM-yyyy',
    );
    // let scheduleEndDate = Moment(this.state.scheduleEndDate).format('DD-MM-yyyy');

    return (
      <View
        style={[
          tableStyle.passwordViewStyle,
          { display: this.state.showAddScheduleViewBool ? 'flex' : 'none' },
        ]}>
        <View
          style={{
            backgroundColor: colors.AppWhite,
            width: 400,
            borderRadius: 5,
          }}>
          <TouchableOpacity
            style={styles.closeBtnViewStyle}
            onPress={() => this.setState({ showAddScheduleViewBool: false })}>
            <Image style={tableStyle.backBtnStyle} source={closeIcon} />
          </TouchableOpacity>
          <Text style={[commonStyle.plainTextStyle, { extAlign: 'center' }]}>
            {this.t('listings.add_schedule_title', 'Add schedule')}
          </Text>
          <View style={{ marginTop: 2, padding: 20 }}>
            <View
              style={{
                zIndex: 9002,
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
              <View>
                <Text style={commonStyle.scheduleTxtStyle}>{this.t('listings.start_date', 'Start Date')}</Text>
                <View
                  style={[
                    appConfigStyle.txtFieldStyle,
                    { marginTop: 5, width: 100 },
                  ]}>
                  <View style={{ position: 'absolute' }}>
                    <DatePicker
                      selected={this.state.scheduleStartDate}
                      onChange={date => this.didSelectDate(date, 1)}
                      dateFormat="MM/dd/yyyy"
                      showTimeInput={false}
                      onCalendarClose={() => this.setState({ calenderOn: false })}
                      onCalendarOpen={() => this.setState({ calenderOn: true })}
                      customInput={
                        <View style={{ height: 20, width: 100 }}>
                          <Text>{scheduleDate}</Text>
                        </View>
                      }
                    />
                  </View>
                </View>
              </View>
              {/* <View>
              <Text style={styles.scheduleTxtStyle}>{this.t('listings.end_date', 'End Date')}</Text>
              <View style={[appConfigStyle.txtFieldStyle, { marginTop: 5, width: 100 }]}>
                <View style={{ position: 'absolute' }}>
                  <DatePicker
                    selected={this.state.scheduleEndDate}
                    onChange={(date) => this.didSelectDate(date,2)}
                    dateFormat="MM/dd/yyyy"
                    showTimeInput={false}
                    onCalendarClose={() => this.setState({ calenderOn: false })}
                    onCalendarOpen={() => this.setState({ calenderOn: true })}
                    customInput={<View style={{ height: 20, width: 100 }}> <Text>{scheduleEndDate}</Text>
                    </View>}
                  />
                </View>
              </View>
            </View> */}
            </View>
            <View
              style={{
                flexDirection: 'row',
                zIndex: 8012,
                justifyContent: 'space-between',
              }}>
              <View style={{ zIndex: 1, marginTop: 10 }}>
                <Text style={commonStyle.scheduleTxtStyle}>{this.t('listings.start_time', 'Start time')}</Text>
                <TouchableOpacity
                  style={[
                    appConfigStyle.txtFieldStyle,
                    {
                      marginTop: 5,
                      width: 100,
                      flexDirection: 'row',
                      alignItems: 'center',
                    },
                  ]}
                  onPress={() => this.openTimePicker(0)}>
                  <Text style={commonStyle.scheduleTxtStyle}>
                    {this.state.scheduleStartTime}
                  </Text>
                </TouchableOpacity>
                <View>
                  <this.renderTimeDropDown id={0} />
                </View>
              </View>
              <View style={{ zIndex: 2, marginTop: 10, marginLeft: 25 }}>
                <Text style={commonStyle.scheduleTxtStyle}>{this.t('listings.end_time', 'End time')}</Text>
                <TouchableOpacity
                  style={[
                    appConfigStyle.txtFieldStyle,
                    {
                      marginTop: 5,
                      width: 100,
                      flexDirection: 'row',
                      alignItems: 'center',
                    },
                  ]}
                  onPress={() => this.openTimePicker(1)}>
                  <Text style={commonStyle.scheduleTxtStyle}>
                    {this.state.scheduleEndTime}
                  </Text>
                </TouchableOpacity>
                <View>
                  <this.renderTimeDropDown id={1} />
                </View>
              </View>
              <View style={{ zIndex: 9812, marginTop: 10, marginLeft: 25 }}>
                <Text style={commonStyle.scheduleTxtStyle}>{this.t('listings.slot', 'Slot')}</Text>
                <TouchableOpacity
                  style={[
                    appConfigStyle.txtFieldStyle,
                    { marginTop: 5, width: 100, flexDirection: 'row' },
                  ]}
                  onPress={() =>
                    this.setState({ showSlotBool: !this.state.showSlotBool })
                  }>
                  <this.renderSlotLable />
                  <this.renderSlotDropDown />
                </TouchableOpacity>
              </View>
            </View>
            <View style={{ zIndex: 6, marginTop: 10 }}>
              {this.renderRepeatView()}
            </View>
            <View style={{ zIndex: 4, alignItems: 'center', marginTop: 20 }}>
              {this.renderSaveScheduleBtn()}
            </View>
          </View>
        </View>
      </View>
    );
  };
  renderSaveBtnView = () => {
    const isEdit = this.props.isEdit;
    return (
      <View>
        <SaveButton
          saveBtn={() => this.submitBtnAction()}
          showSaveBtn={true}
          saveBtnTitle={isEdit ? this.t('listings.update', 'Update') : this.t('listings.save', 'Save')}
          btnDeActive={!this.state.writeP}
          showLock={true}
        />
      </View>
    );
  };
  renderTaxView = () => {
    if (this.state.listing_taxes.length > 0) {
      return (
        <View style={[styles.firstViewStyle]}>
          <View style={{ margin: 16 }}>
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
              <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.tax', 'Tax')}</Text>
            </View>

            <TouchableOpacity
              style={[styles.dropDownViewStyle, { borderWidth: 1 }]}
              onPress={() =>
                this.setState({ showTaxDropDown: !this.state.showTaxDropDown })
              }>
              <View style={styles.dropdownLabelStyle}>
                <Text
                  style={
                    this.state.selected_listing_tax
                      ? appConfigStyle.txtFieldStyleDropDown
                      : appConfigStyle.placeholderTxtStyle
                  }>
                  {this.state.selected_listing_tax?.title || this.t('listings.select_tax', 'Select tax')}
                </Text>
                <Image
                  style={
                    this.state.showTaxDropDown
                      ? appConfigStyle.upArraowIconStyle
                      : appConfigStyle.downArraowIconStyle
                  }
                  resizeMode="contain"
                  source={downArrow_Icon}
                />
              </View>
              {this.state.showTaxDropDown && (
                <View style={commonStyle.showDropDownViewStyle}>
                  <FlatList
                    data={this.state.listing_taxes}
                    horizontal={false}
                    renderItem={({ item }) => (
                      <TouchableOpacity
                        onPress={() => {
                          this.setState({
                            selected_listing_tax: item,
                            showTaxDropDown: false,
                          });
                        }}
                        style={{ margin: 5, height: 30, marginBottom: 5 }}>
                        <View
                          style={{
                            justifyContent: 'center',
                            width: '100%',
                            padding: 5,
                          }}>
                          <Text style={CommonStyleSheet.plainSubTextStyle}>
                            {item.title}
                          </Text>
                        </View>
                      </TouchableOpacity>
                    )}
                    keyExtractor={item => item.id.toString()}
                  />
                </View>
              )}
            </TouchableOpacity>
          </View>
        </View>
      );
    }
    return null;
  };
  render() {
    const isEdit = this.props.isEdit;
    return (
      <SafeAreaView style={styles.Container}>
        <ToastContainer />
        <this.renderAddScheduleView />
        {/* <Header_View
          title={isEdit ? this.t('listings.edit_listing', 'Edit listing') : this.t('listings.add_listing', 'Add listing')}
          backBtn={this.props.backBtnAction}
          saveBtnTitle={isEdit ? this.t('listings.update', 'Update') : this.t('listings.save', 'Save')}
          saveBtn={() => this.submitBtnAction()}
        /> */}
        <View style={tableStyle.navigationViewStyle}>
          <ListingsHeaderV2
            simple={true}
            titleArea={
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
              <TouchableOpacity
                style={tableStyle.backBtnBackViewStyle}
                onPress={
                  this.props.backBtnAction
                    ? this.props.backBtnAction
                    : () =>
                      this.props.navigate(
                        isEdit
                          ? `/listing/${this.props.params.listingID}`
                          : '/listings',
                      )
                }>
                <Image
                  style={tableStyle.backBtnStyle}
                  resizeMode="center"
                  source={backIcon}
                />
              </TouchableOpacity>
                <Text style={[tableStyle.titleTextStyle, {color: this.context?.colors?.primaryText ?? colors.AppTitleBlack}]}>
                  {isEdit ? this.t('listings.edit_listing', 'Edit listing') : this.t('listings.add_listing', 'Add listing')}
                </Text>
              </View>
            }
            actionControl={
              <View style={{flexDirection: 'row', alignItems: 'center'}}>
              {this.renderSaveBtnView()}
              </View>
            }
          />
        </View>
        {this.state.readP && (
          <View style={{ height: windowHeight / 1.16 }}>
            <ScrollView>
              <View style={{ flexDirection: itsMobileView ? 'column' : 'row' }}>
                {this.mediaManagerView()}
                {this.renderMapView()}
                <View style={styles.leftMainView}>
                  {/* <Text style={styles.titleStyle}>Listing Data</Text> */}
                  <View style={styles.firstViewStyle}>
                    <View style={styles.marginStyleView}>
                      {/* <Text style={appConfigStyle.titleTxtStyle}>Title</Text> */}
                      <TextInput
                        style={[appConfigStyle.txtFieldStyle, { outline: 0 }]}
                        placeholder={this.t('listings.enter_title', 'Enter title')}
                        placeholderTextColor={colors.placeholderColor}
                        onChangeText={txt => this.setState({ titleString: txt })}
                        value={this.state.titleString}
                      />
                    </View>
                    {this.renderSlugField()}
                    <View style={{ margin: 16, marginTop: 0 }}>
                      {this.renderDescriptionView()}
                    </View>
                  </View>
                  <this.renderListingImageView />
                  <View style={{ height: 26 }} />
                  {this.renderTagView()}
                  {this.renderMetaData()}
                </View>
                <View style={styles.mainView}>
                  {(this.state.order_type === 'digital' ||
                    this.props?.type === 'digital') && (
                      <AddDigitalProduct
                        digitalProducts={this.state.digitalProducts}
                        setDigitalProducts={digitalProducts =>
                          this.setState({ digitalProducts })
                        }
                        isEdit={isEdit}
                        listingId={this.props.params.listingID}
                      />
                    )}

                  {/*  user section  */}
                  {!AppConstants.appType && (
                    <View style={[styles.firstViewStyle, { zIndex: 120 }]}>
                      <View style={{ margin: 16 }}>
                        <View
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                          }}>
                          <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.account', 'Account')}</Text>
                        </View>

                        <SetupAccount
                          onSelectAccount={account => {
                            this.setState({ selectedAccount: account });
                          }}
                          selectedAccount={this.state.selectedAccount}
                        />
                      </View>
                    </View>
                  )}

                  {/*  */}
                  <View style={styles.firstViewStyle}>
                    <View style={{ zIndex: 1234 }}>
                      {this.renderCurrencyView()}
                    </View>
                    <View
                      style={[
                        appConfigStyle.listingTxtFieldContainerStyle,
                        { zIndex: 1 },
                      ]}>
                      <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.list_price', 'List Price')}</Text>
                      <TextInput
                        style={[
                          appConfigStyle.listingTextFieldStyle,
                          { outline: 0 },
                        ]}
                        placeholder={this.t('listings.enter_list_price', 'Enter List Price')}
                        placeholderTextColor={colors.placeholderColor}
                        onChangeText={text => this.onHandleTextChange(text, 0)}
                        value={this.state.listPriceValue}
                      />
                    </View>
                    <View style={{ zIndex: 2 }}>{this.renderOfferView()}</View>
                    <View style={{ zIndex: 2 }}>{this.renderStockView()}</View>
                    <View style={{ zIndex: 2 }}>{this.renderMaxQntyView()}</View>
                  </View>
                  <View style={{ height: 20 }} />
                  {/* <Text style={styles.titleStyle}>Listings Detail</Text> */}
                  <View style={[styles.firstViewStyle, { zIndex: 120 }]}>
                    <View style={{ margin: 16 }}>
                      <View
                        style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }}>
                        <Text style={appConfigStyle.titleTxtStyle}>{this.t('listings.categories', 'Category')}</Text>
                        <Text
                          style={appConfigStyle.titleTxtStyle}
                          onPress={() => this.setState({ openSidepan: true })}>{this.t('listings.add_category', '+ Add Category')}</Text>
                      </View>

                      <View style={styles.dropDownViewStyle}>
                        <View style={{ width: '100%' }}>
                          <SelectSearchView
                            value={this.state.selectedCategoryArray}
                            onChange={itm => this.handleSelectChange(itm)}
                            options={this.state.categoriesArray}
                            isMulti={true}
                            placeholder={this.t('listings.select_categories', 'Select categories')}
                            styles={colourStyles}
                            theme={theme => ({
                              ...theme,
                              borderRadius: 0,
                              colors: {
                                ...theme.colors,
                                primary25: colors.AppGreenBorder,
                                primary: colors.AppGreenBorder,
                              },
                            })}
                          />
                        </View>
                      </View>
                    </View>
                  </View>
                  {this.state.listing_taxes.length > 0 && this.renderTaxView()}
                  <this.renderArttributes />
                  <this.renderScheduleView />
                  <View
                    style={{
                      zIndex: 10,
                      display:
                        AppConstants.moduleType == ModuleType.event
                          ? 'flex'
                          : 'none',
                    }}>
                    <this.renderAddScheduleBtn />
                  </View>
                </View>
                {/* <View style={{width: 1, height: '100%', backgroundColor: colors.SimonGray}} /> */}
                {/* <this.renderPreviewView /> */}
              </View>
            </ScrollView>
          </View>
        )}
        <Appload enable={this.state.dataLoad} />

        <SidePan
          openSidepan={this.state.openSidepan}
          closeSipan={() => this.setState({ openSidepan: false })}
          sidepan_width={windowWidth - 250}>
          <AddCategory
            type={'Listings'}
            isEdit={false}
            closeBtnAction={() => this.setState({ openSidepan: false })}
            backBtnAction={() => this.setState({ openSidepan: false })}
          />
        </SidePan>
      </SafeAreaView>
    );
  }
}

export default withRouter(withLocale(AddListings));

const colourStyles = {
  control: styles => ({
    ...styles,
    backgroundColor: 'var(--color-input)',
    borderColor: 'var(--color-border)',
    borderRadius: 5,
  }),
  menu: styles => ({
    ...styles,
    backgroundColor: 'var(--color-surface)',
    color: 'var(--color-text)',
    zIndex: 10000,
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    // const color = chroma(data.color);
    return {
      ...styles,
      backgroundColor: isDisabled
        ? 'var(--color-surface)'
        : isSelected
          ? 'var(--color-accent)'
          : isFocused
            ? 'var(--color-input)'
            : 'var(--color-surface)',
      color: isDisabled
        ? 'var(--color-text-secondary)'
        : isSelected
          ? 'var(--color-bg)'
          : 'var(--color-text)',
      cursor: isDisabled ? 'not-allowed' : 'default',
      ':active': {
        ...styles[':active'],
        backgroundColor:
          !isDisabled && (isSelected ? data.color : colors.Lightgray),
      },
    };
  },
  input: styles => ({...styles, color: 'var(--color-text)'}),
  placeholder: styles => ({...styles, color: 'var(--color-text-secondary)'}),
  singleValue: styles => ({...styles, color: 'var(--color-text)'}),
  multiValue: styles => ({...styles, backgroundColor: 'var(--color-surface)'}),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: 'var(--color-text)',
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
    ':hover': {
      backgroundColor: data.color,
      color: colors.AppRed,
    },
  }),
};

let slotArray = [
  { name: '15', id: 0 },
  { name: '30', id: 1 },
  { name: '45', id: 2 },
  { name: '60', id: 3 },
  // { 'name': 'Custom', 'id': 4 }
];
